import React from "react";
import PropTypes from "prop-types";
import { useInView } from "react-intersection-observer";

// images
import passionIcon from "../../../images/career/passion.png";
import talentIcon from "../../../images/career/talent.png";
import trustIcon from "../../../images/career/trust.png";
import circleImage from "../../../images/career/circle.png";

// styles
import * as styles from "./OurCulture.module.css";

const propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  bottomText: PropTypes.string,
  values: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
    })
  ),
};

const defaultProps = {
  title: "Our Culture & Values",
  description:
    "At Twin Health, our culture is built on the pillars of passion, talent, and trust. We believe these qualities empower us to create transformative solutions that change lives.",
  bottomText:
    "Together, we are building a future where technology and human care combine to create healthier, happier communities.",
  values: [
    {
      icon: passionIcon,
      title: "Passion",
      description:
        "We are driven by a shared mission to improve health and well-being. Every member of our team is committed to making a meaningful impact through their work.",
    },
    {
      icon: talentIcon,
      title: "Talent",
      description:
        "At Twin Health, we celebrate individual strengths and encourage continuous learning. We thrive on innovation and empower our employees to reach their full potential.",
    },
    {
      icon: trustIcon,
      title: "Trust",
      description:
        "Collaboration and transparency are at the heart of what we do. We trust in each other's abilities and are dedicated to fostering an environment of mutual respect and accountability.",
    },
  ],
};

const OurCulture = ({ title, description, bottomText, values }) => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  return (
    <section className={styles.ourCultureWrapper}>
      <div
        className={`container scroll_animate ${inView && "inview"}`}
        ref={ref}
      >
        {/* Header Section */}
        <div className={styles.headerSection}>
          <h2 className={styles.title}>{title}</h2>
          <p className={styles.description}>{description}</p>
        </div>

        {/* Values Cards */}
        <div className={styles.valuesContainer}>
          <div className="row">
            {values.map((value, index) => (
              <div key={index} className="col-lg-4 col-md-6 col-12">
                <div className={styles.valueCard}>
                  <div className={styles.iconContainer}>
                    <img
                      src={value.icon}
                      alt={value.title}
                      className={styles.valueIcon}
                    />
                  </div>
                  <h3 className={styles.valueTitle}>{value.title}</h3>
                  <p className={styles.valueDescription}>{value.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Bottom Section */}
        <div className={styles.bottomSection}>
          <p className={styles.bottomText}>{bottomText}</p>
          <div className={styles.circleImageContainer}>
            <img
              src={circleImage}
              alt="Circle decoration"
              className={styles.circleImage}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

OurCulture.propTypes = propTypes;
OurCulture.defaultProps = defaultProps;

export default OurCulture;
